module.exports = {"210624100":"宽甸镇","210624101":"灌水镇","210624102":"硼海镇","210624103":"红石镇","210624104":"毛甸子镇","210624105":"长甸镇","210624106":"永甸镇","210624108":"太平哨镇","210624109":"青山沟镇","210624110":"牛毛坞镇","210624111":"大川头镇","210624112":"青椅山镇","210624113":"杨木川镇","210624114":"虎山镇","210624115":"振江镇","210624116":"步达远镇","210624117":"大西岔镇","210624118":"八河川镇","210624119":"双山子镇","210624201":"石湖沟乡","210624206":"古楼子乡","210624212":"下露河朝鲜族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210624.json
// module id = 500
// module chunks = 0